<template>
  <div class="forget">
    <div class="forget-head-border">
      <img src="@/assets/img/shopvidi_logo.png" class="logo_img" @click="gotoShopvidi"/>
    </div>
    <el-steps :active="currentTab" finish-status="success">
      <el-step title="E-mail verification"></el-step>
      <el-step title="Password"></el-step>
      <el-step title="Complete"></el-step>
    </el-steps>
    <div class="forget-body">
      <step2 v-if="currentTab === 0" @nextStep="nextStep" />
      <step3 v-if="currentTab === 1" @nextStep="nextStep" @prevStep="prevStep" :userInfo="userInfo" />
      <step4 v-if="currentTab === 2" @prevStep="prevStep" @finish="finish" :userInfo="userInfo" />
    </div>
  </div>
</template>

<script>
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'

export default {
  name: 'Forget',
  props: ['showLogin'],
  components: {
    Step2,
    Step3,
    Step4

  },
  data() {
    return {
      fullWidth: document.documentElement.clientWidth,
      show: false, // 控制移动端的布局不同
      description: '将一个冗长或用户不熟悉的表单任务分成多个步骤，指导用户完成。',
      currentTab: 0,
      userList: {},
      userInfo: {},
      // form
      form: null
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    if (this.fullWidth <= 420) {
      this.show = true
    }
  },
  methods: {
    gotoShopvidi() {
      this.$router.push('/')
    },
    handleResize(event) {
      this.fullWidth = document.documentElement.clientWidth
    },
    // handler
    nextStep(data) {
      this.userInfo = data
      if (this.currentTab < 4) {
        this.currentTab += 1
      }
    },
    prevStep(data) {
      this.userInfo = data
      if (this.currentTab > 0) {
        this.currentTab -= 1
      }
    },
    finish() {
      this.$emit('showLogin')
    }
  }
}
</script>

<style lang="less" scoped>
.forget {
  width: 600px;
  max-width: 90%;
  margin: 0 auto;
}

.forget-body{
  margin-top: 60px;
  font-weight: 700;
  color: #000;
}
.parent {
  position: relative;
}
.logo-img {
  position: absolute;
  top: -135px;
  left: -10vw;
}
.forget-head-border{
  text-align: center;
  margin:30px 0px;
  .logo_img{
    width: 200px;
    cursor: pointer;
  }
}
@media screen and (max-width: 420px) {
  .parent {
    position: static;
  }
  .logo-img {
    left: 0;
    margin-top: -140px;
    position: static;
  }
  .ant-divider.ant-divider-horizontal {
    width: 100%;
  }
  .ant-steps.ant-steps-horizontal.ant-steps-label-horizontal {
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/forget/index.vue